import { createContext, useContext, useEffect, useState } from "react";

const RegionContext = createContext(null);

const CONFIG = {
  AU: {
    code: "AU",
    label: "Australia",
    flag: "🇦🇺",
    currency: "AUD",
    phone: "+61 420 714 453",
    email: "info@allthingssocialimpact.com",
    entity: "All Things Social Impact Pty Ltd - ABN 18 676 008 496",
    address: "Brisbane, Queensland, Australia",
    tagline: "Advisory for Australian energy, resources and infrastructure leaders.",
    keyFramework: "Queensland Social Impact Assessment Guideline (2018) - authored by Andrea.",
    industryLingo: {
      infrastructure: "Infrastructure, Utilities & Transport",
      procurement: "Local content & procurement",
    },
  },
  US: {
    code: "US",
    label: "United States",
    flag: "🇺🇸",
    currency: "USD",
    phone: "+1 (737) 738 8334",
    email: "info@allthingssocialimpact.com",
    entity: "All Things Social Impact LLC - EIN 42-4439233, Austin, Texas, USA",
    address: "Austin, Texas, USA",
    tagline: "Advisory for US energy transition, resources and community outcomes.",
    keyFramework: "Aligned with IFC PS1–8, Equator Principles, and US NEPA/state-level frameworks.",
    industryLingo: {
      infrastructure: "Infrastructure, Utilities & Transportation",
      procurement: "Local hire & supplier development",
    },
  },
};

export const RegionProvider = ({ children }) => {
  const [region, setRegionState] = useState(() => {
    if (typeof window === "undefined") return "AU";
    return localStorage.getItem("region_pref") || "AU";
  });

  useEffect(() => {
    localStorage.setItem("region_pref", region);
  }, [region]);

  const setRegion = (r) => setRegionState(r === "US" ? "US" : "AU");

  return (
    <RegionContext.Provider value={{ region, config: CONFIG[region], setRegion, allConfigs: CONFIG }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => {
  const ctx = useContext(RegionContext);
  if (!ctx) throw new Error("useRegion must be used within RegionProvider");
  return ctx;
};
